import axios from "axios"
import { reportAddToCart } from "../api"
import { shopifyAddToCart } from "./variant"
import { Product, ProductIdentifier } from "src/types"
import { SlotReference } from "@/utils/resolveSlotId"

/**
 * Helper function for Shopify's cart API to add a single item to the shopping cart.
 * This function is used for adding a product using the handle in is used in legacy
 * Shopify implementations. The handle is used to lookup the product information
 * and use the cart API to add the first variant to the shopping cart.
 *
 * @deprecated
 * @param {string} handle - the handle of the product to add to the cart
 * @param {Node} element - the element that was clicked
 * @param {Integer} quantity - the quantity to be added (or 1)
 * @author oostman
 * @author mridang
 */
export default async function (handle: string, element: SlotReference, quantity: number) {
  const amount = quantity || 1

  const res = await axios.get<Product>(`/products/${handle}.js`)
  const response = res.data
  if (!response || !response.variants || response.variants.length === 0) {
    throw new Error("Unable to find a variation in the product")
  }
  await shopifyAddToCart(response.variants[0].id, amount)
  // XXX legacy function which misses skuId
  return await reportAddToCart({ productId: response.id } as ProductIdentifier, element)
}
